// extracted by mini-css-extract-plugin
module.exports = {"buttonColor":"ButtonTransparentV2_buttonColor__4v1bD","buttonSize":"ButtonTransparentV2_buttonSize__6f1MB","buttonPadding":"ButtonTransparentV2_buttonPadding__EhcT3"};